import {
  SYS_COLOR_CANVAS_100_DARK,
  SYS_COLOR_CANVAS_200_DARK,
  SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_200_FILL_DARK,
  SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_100_FILL_DARK,
  SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
  SYS_COLOR_ELEVATION_LEVEL1_STROKE_DARK,
  SYS_COLOR_ELEVATION_LEVEL2_FILL_STOPS_0_DARK,
  SYS_COLOR_INTERNAL_BROWSER_DEFAULTS_MENU_BACKGOUND_DARK,
  SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
  SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK,
  SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
  SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK,
  SYS_COLOR_FOREGROUND_DISABLED_100_DARK,
  SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK,
  SYS_BORDER_RADIUS_SM,
  SYS_BORDER_RADIUS_MAX,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_DARK,
  SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DEFAULT_DARK,
  SYS_COLOR_FOREGROUND_INTERACTIVE_ON_FORM_CONTROLS_SELECTED_100_LIGHT,
  SYS_COLOR_INTERNAL_BROWSER_DEFAULTS_MENU_ITEM_TEXT_DARK,
  SYS_COLOR_FOREGROUND_ON_FORMFIELDS_SUBDUED_DARK,
} from '@oneaudi/unified-web-alpha-common-v2';

export const ALPHA_THEME = {
  canvas100: SYS_COLOR_CANVAS_100_DARK,
  canvas200: SYS_COLOR_CANVAS_200_DARK,
  sidebarTablet: SYS_COLOR_SURFACE_INTERACTIVE_NAVIGATION_200_FILL_DARK,
  sidebarDesktop: SYS_COLOR_SURFACE_INTERACTIVE_QUATERNARY_100_FILL_DARK,
  cardSurface: SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
  borderSubtle: SYS_COLOR_ELEVATION_LEVEL1_STROKE_DARK,
  textCopyDefault: SYS_COLOR_FOREGROUND_INTERACTIVE_ON_FORM_CONTROLS_SELECTED_100_LIGHT,
  defaultItemTextDark: SYS_COLOR_INTERNAL_BROWSER_DEFAULTS_MENU_ITEM_TEXT_DARK,
  foregroundNeutral100: SYS_COLOR_FOREGROUND_NEUTRAL_100_DARK,
  foregroundNeutral200: SYS_COLOR_FOREGROUND_NEUTRAL_200_DARK,
  foregroundNeutral300: SYS_COLOR_FOREGROUND_NEUTRAL_300_DARK,
  foregroundNeutral400: SYS_COLOR_FOREGROUND_NEUTRAL_400_DARK,
  foregroundDisabled100: SYS_COLOR_FOREGROUND_DISABLED_100_DARK,
  foregroundSignalNegative: SYS_COLOR_FOREGROUND_SIGNAL_NEGATIVE_DARK,
  borderRadiusSm: SYS_BORDER_RADIUS_SM,
  borderRadiusMax: SYS_BORDER_RADIUS_MAX,
  spaceFixed100: SYS_SPACE_FIXED_100,
  spaceFixed200: SYS_SPACE_FIXED_200,
  formFieldFill: SEM_COLOR_FORMS_SURFACE_FIELD_FILL_DEFAULT_DARK,
  formFieldStroke: SEM_COLOR_FORMS_SURFACE_FIELD_STROKE_DEFAULT_DARK,
  foregroundOnFormfieldsSubdued: SYS_COLOR_FOREGROUND_ON_FORMFIELDS_SUBDUED_DARK,
  menuBackgroundDark: SYS_COLOR_INTERNAL_BROWSER_DEFAULTS_MENU_BACKGOUND_DARK,
  elevationFillStopDark: SYS_COLOR_ELEVATION_LEVEL2_FILL_STOPS_0_DARK,
};

export type AlphaTheme = typeof ALPHA_THEME;
